var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"face-auth-result"},[_c('div',{staticClass:"face-auth-result-body",on:{"click":_vm.leftClick}},[_vm._m(0),_vm._m(1)]),_c('div',{staticClass:"FaceDialog"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("人脸核身操作完成，去看课")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"face-auth-result-confirm"},[_vm._v("确定")])])
}]

export { render, staticRenderFns }